import Vue from 'vue'
import Router from 'vue-router'
import loginBack from '@/page/loginBack'
import Activities from '@/page/activities'
import GetStudentInfo from  '@/page/GetStudentInfo'
import scanningLogin from  '@/page/scanningLogin'

Vue.use(Router)

export default new Router({
  mode: "history",
  base: '/cos/',
  routes: [{
      path: '/',
      name: 'Activities',
      component: Activities
    },{
      path: '/loginBack',
      name: 'loginBack',
      component: loginBack
    },{
      path: '/getInfo',
      name: 'GetStudentInfo',
      component: GetStudentInfo
    },{
      path: '/scanningLogin',
      name: 'scanningLogin',
      component: scanningLogin
    }
  ]
})
